import React from 'react';
import { Waypoint } from 'react-waypoint';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export default class Image extends React.Component {

	constructor(props) {
		super(props);

		let {src, type, lazyLoad} = this.props;

		const placeholder = 'placeholder.jpg';

		if (!src) {
			src = `/static/images/program/${placeholder}`;
		}

		const pathSegments = src.split('/');
		const fileName = pathSegments[pathSegments.length - 1];
		const path = pathSegments.slice(0, pathSegments.length - 1).join("/");

		let w = 1200;

		if (type === 'program' || type === 'large') {
			w = 1080;
		} else if (type === 'thumbnail') {
			w = 450;
		} else if (type === 'four-col') {
			w = 300;
		}

		let srcDisplay = `${config.cdnUrl}${path}/w${w}/${fileName}`;
		if (lazyLoad) {
			srcDisplay = `${config.cdnUrl}${path}/w${w}/${placeholder}`;
		}

		this.state = {
			srcReal: `${config.cdnUrl}${path}/w${w}/${fileName}`,
			srcDisplay
		}
	}

	_handleWaypointEnter = () => {
		this.setState({
			srcDisplay: this.state.srcReal
		});
	};

	render() {
		let {src, type, alt, lazyLoad, ...rest} = this.props;

		if (!src) {
			return null;
		}

		if (typeof alt === 'undefined') {
			alt = src.substring(src.lastIndexOf('/') + 1);
			alt = alt.substring(0, alt.lastIndexOf('.'));
		}

		src = this.state.srcDisplay;

		return (
			<React.Fragment>
				{ (lazyLoad)? <Waypoint onEnter={this._handleWaypointEnter} bottomOffset={-200} /> : null }
				<img {...rest} src={src} alt={alt} />
			</React.Fragment>
		);
	}
}
